import {
  CCSD_DEFAULT_CHANGES_BULK_CHECK_REQUEST,
  CCSD_DEFAULT_CHANGES_CHECK_SUCCESS,
  CCSD_DEFAULT_CHANGES_LIST_CLEAR_FILTERS,
  CCSD_DEFAULT_CHANGES_LIST_ERROR,
  CCSD_DEFAULT_CHANGES_LIST_REQUEST,
  CCSD_DEFAULT_CHANGES_LIST_SET_FILTERS,
  CCSD_DEFAULT_CHANGES_LIST_SET_PAGE,
  CCSD_DEFAULT_CHANGES_LIST_UNLOAD,
  CCSD_DEFAULT_CHANGES_LIST_UPDATED,
} from '../constants';
import { hydraPageCount } from '../../helper/apiUtils';
import { removeFiltersFromSession, setFiltersInSession } from '../../routing/filters';

const reducer = (
  state = {
    ccsdDefaultChanges: [],
    currentPage: 1,
    pageCount: null,
    isFetchingCcsdDefaultChanges: false,
    filters: {},
  },
  action,
) => {
  switch (action.type) {
    case CCSD_DEFAULT_CHANGES_LIST_REQUEST:
    case CCSD_DEFAULT_CHANGES_BULK_CHECK_REQUEST:
      return { ...state, isFetchingCcsdDefaultChanges: true };
    case CCSD_DEFAULT_CHANGES_LIST_UPDATED:
      return {
        ...state,
        ccsdDefaultChanges: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingCcsdDefaultChanges: false,
      };
    case CCSD_DEFAULT_CHANGES_LIST_SET_PAGE:
      return { ...state, currentPage: action.page };
    case CCSD_DEFAULT_CHANGES_LIST_UNLOAD:
      return { ccsdDefaultChanges: [], currentPage: 1, pageCount: null, isFetchingCcsdDefaultChanges: false, filters: {} };
    case CCSD_DEFAULT_CHANGES_LIST_ERROR:
      return { ...state, isFetchingCcsdDefaultChanges: false, ccsdDefaultChanges: [] };
    case CCSD_DEFAULT_CHANGES_LIST_SET_FILTERS:
      setFiltersInSession(action.routeKey || null, action.filters);
      return { ...state, filters: action.filters };
    case CCSD_DEFAULT_CHANGES_LIST_CLEAR_FILTERS:
      removeFiltersFromSession(action.routeKey || null);
      return { ...state, filters: {} };
    case CCSD_DEFAULT_CHANGES_CHECK_SUCCESS:
      return {
        ...state,
        ccsdDefaultChanges: state.ccsdDefaultChanges.map((dc) => (dc.id === action.data.id ? action.data : dc)),
      };
    default:
      return state;
  }
};

export default reducer;